/**
 * Reusable logic for dispatching a redux action on a set interval,
 * optionally throttled by time and other factors. Useful for features like autosave.
 * @param {Function} action - a dispatch()-wrapped action to repeatedly trigger
 * @param {{seconds: number, blocking: boolean}} options - Triggers for the save option. Currently supported:
 * * @param options.seconds number of seconds after which to trigger a save.
 * * @param options.blocking if true, you cannot dispatch a new action while the old one is resolving. action MUST return a Promise to use this option
 * @return {Function} - call this function to cancel future scheduled actions for this resource.
 */
export default (action, options) => {
  let interval;
  let exec = action;

  if (options.blocking) {
    let isResolved = true;
    let promiseFromLastCall = Promise.resolve();

    exec = () => {
      if (isResolved) {
        isResolved = false;
        promiseFromLastCall = action();
        promiseFromLastCall
          .then(res => {
            isResolved = true;
            return res;
          })
          .catch(() => {
            isResolved = true;
          });
      }
    };
  }

  if (options.seconds && typeof options.seconds === "number") {
    interval = setInterval(exec, options.seconds * 1000);
  }

  return {
    interval: options.seconds,
    cancel() {
      if (interval) {
        clearInterval(interval);
        this.interval = false;
      }
    },
  };
};
